import { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedLayout from "./layouts/ProtectedLayout";
import ScrollToTop from "./components/ScrollToTop";

const Home = lazy(() => import("./pages/Home.tsx"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Profile = lazy(() => import("./pages/Profile"));
const AdminUsers = lazy(() => import("./pages/AdminUsers"));
const Announcements = lazy(() => import("./pages/Announcements"));
const Projects = lazy(() => import("./pages/Projects"));
const Publications = lazy(() => import("./pages/Publications"));
const Messages = lazy(() => import("./pages/Messages"));
const Matching = lazy(() => import("./pages/Matching"));
const Connections = lazy(() => import("./pages/Connections"));
const AutoMatching = lazy(() => import("./pages/AutoMatching"));

function RouteFallback() {
  const { t } = useTranslation();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          minWidth: 220,
          padding: "16px 18px",
          borderRadius: 18,
          border: "1px solid var(--border)",
          background: "var(--card)",
          boxShadow: "var(--shadow)",
          color: "var(--text)",
          textAlign: "center",
        }}
      >
        {t("common.loading")}
      </div>
    </div>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<Navigate to="/admin/users" replace />} />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requiredRoles={["ADMIN", "SUPERVISOR"]}>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/matching" element={<Matching />} />
            <Route path="/auto-matching" element={<AutoMatching />} />
            <Route path="/connections" element={<Connections />} />
            <Route path="/connections/requests" element={<Navigate to="/connections" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
